import { render } from "./LessonBlockCard.vue?vue&type=template&id=63ad34e4"
import script from "./LessonBlockCard.vue?vue&type=script&lang=js"
export * from "./LessonBlockCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__